<template>
  <div class="call_out_monitor" :style="screenHeight">
    <div class="fixed_search">
      <div class="fixed_search_input">
        <Input v-model="employeeMobile" placeholder="请输入手机号码" title="手机号码"/>
      </div>
      <div class="fixed_search_input">
        <Input v-model="agentNumber" placeholder="请输入员工工号" title="员工工号"/>
      </div>
      <div class="fixed_search_input">
        <Input v-model="agentname" placeholder="请输入员工姓名" title="员工姓名"/>
      </div>
      <div class="fixed_search_input">
        <Input v-model="pstnNumber" placeholder="请输入热线号码" title="热线号码"/>
      </div>
      <div class="fixed_search_input">
        <Select v-model="countdown" placeholder="刷新时间选择" class="countdown_select" filterable @on-change="handleCountdown">
          <Option v-for="(item,index) in countdownList" :value="item.value" :key="index">{{ item.name }}</Option>
        </Select>
      </div>
      <div class="fixed_operation_btn">
        <Button type="primary" @click="initSearch">查询</Button>
        <div class="countdown_input" title="刷新倒计时">{{countdownTime}}</div>
      </div>
    </div>
    <div class="fixed_table">
      <Spin size="large" fix v-if="spinShow"><Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon><div>正在加载中...</div></Spin>
      <div class="table_head">
        <table>
          <tr>
            <th class="font_style_set" style="width:8%;">手机号码</th>
            <th class="font_style_set" style="width:10%;">员工工号</th>
            <th class="font_style_set" style="width:10%;">员工姓名</th>
            <th class="font_style_set" style="width:10%;">呼出时间</th>
            <th class="font_style_set" style="width:9%;">技能组号码</th>
            <th class="font_style_set" style="width:8%;">热线号码</th>
            <th class="font_style_set" style="width:10%;">呼叫状态</th>
          </tr>
        </table>
      </div>
      <div class="footer_style" :style="tableHeight">
        <table class="table_head_footer">
          <tr v-for="(item , index) in infoTableList" :key="index" :id="item.id" :class="{back_color:(index+1)%2==0}">
            <td  style="width:8%;">{{item.telnumber}}</td>
            <td  style="width:10%;">{{item.agentNum}}</td>
            <td  style="width:10%;">{{item.agentname}}</td>
            <td  style="width:10%;">{{item.lastCallTime}}</td>
            <td  style="width:9%;">{{item.queuenum}}</td>
            <td  style="width:8%;">{{item.pstnNumber}}</td>
            <td  style="width:10%;">{{item.callStatus}}</td>
          </tr>
        </table>
      </div>
      <div class="footer_monitor">
        <div>已分配:{{agentStatus.inAllot}}</div>
        <div>呼叫中:{{agentStatus.inCall}}</div>
        <div>IVR中:{{agentStatus.inIvr}}</div>
        <div>队列中:{{agentStatus.inQueue}}</div>
        <div>离线:{{agentStatus.sumOffline}}</div>
        <div>空闲:{{agentStatus.sumFree}}</div>
        <div>振铃:{{agentStatus.sumRing}}</div>
        <div>通话中:{{agentStatus.sumCall}}</div>
        <div>呼叫保持:{{agentStatus.sumHold}}</div>
        <div>后处理:{{agentStatus.sumHandle}}</div>
        <div>被占用:{{agentStatus.sumOccupy}}</div>
        <div>忙碌:{{agentStatus.sumBusy}}</div>
        <div>仅呼出:{{agentStatus.sumOut}}</div>
      </div>
    </div>
    <div class="page_style">
      <Page :total="total" size="small" :page-size='pageSize' :current='currentPage' :page-size-opts="pageSizeList" show-total show-sizer  @on-change="changeCurrent" @on-page-size-change="changeSize"/>
      <div style="padding-top: 2px;">跳至</div><Input class="show-elevator" v-model="speedChangePage" @on-blur="handleCurrentPage"/><div style="padding-top: 2px;">页</div>
    </div>
  </div>
</template>

<script>
    import {publicFunClass} from '@/components/js/PublicFunClass.js'
    export default {
        name: "callOutMonitor",
        mixins:[publicFunClass],
        props:{
          pageCode:String
        },
        data(){
          return{
            showPageCount:0,
            spinShow:true,
            editable:false,
            infoTableList:[],
            countdown:'5',
            historyTime:5,
            countdownTime:5,
            countdownList:[{'value':'0','name':'停止刷新'},{'value':'5','name':'每隔5秒刷新'},{'value':'10','name':'每隔10秒刷新'},{'value':'15','name':'每隔15秒刷新'},{'value':'20','name':'每隔20秒刷新'},{'value':'25','name':'每隔25秒刷新'},{'value':'30','name':'每隔30秒刷新'}],
            total:0,
            readonly:true,
            pageSizeList:[10,20,30,40,50,100,200],
            currentPage:1,
            speedChangePage: 1,
            pageSize:20,
            tableHeight:{height:''},
            screenHeight:{height:''},
            starEndTime:[],
            pstnNumber:'',
            agentname:'',
            agentNumber:'',
            employeeMobile:'',
            Interval:-1,
            configInfo: JSON.parse(localStorage.getItem("configInfo")),
            agentStatus:[],
          }
        },
        methods:{
          //创建刷新时间
          handleCreate:function(val){
            let reg=/^[0-9]*$/;
            if(!reg.test(val)){
              this.$Modal.info({
                title:'提示',
                content:"刷新时间只能输入数字"
              });
              clearInterval(this.Interval);
              this.countdownTime="刷新已停止";
              return false;
            }
            if(val<5){
              this.$Modal.info({
                title:'提示',
                content:"刷新时间不能小于5秒"
              });
              clearInterval(this.Interval);
              this.countdownTime="刷新已停止";
              return false;
            }
            let param={
              value:val,
              name:'每隔'+val+'秒刷新'
            };
            this.countdownList.unshift(param);
            this.countdown=val;
            this.countdownTime=parseInt(val);
          },
          //切换刷新时间
          handleCountdown:function(val){
            if(val){
              this.countdownTime= parseInt(val);
            }else{
              if(this.countdownTime <= 0)
              return;
            }

            if(val=='0'){
              clearInterval(this.Interval);
              this.countdownTime="刷新已停止";
              return false;
            }
            val = this.countdownTime;
            clearInterval(this.Interval);
            let reg=/^[0-9]*$/;
            if(reg.test(val)){
              val=parseInt(val);
              this.countdownTime=parseInt(val);
              this.historyTime=parseInt(val);
              let that=this;
              this.Interval= setInterval(() =>{
                that.initCountdown();
              },1000);
            }
          },
          initSearch:function () {
            this.spinShow=false;
            let that=this;
            let param={
              journalType:"null",
              menuId:"null",
              pageNum:this.currentPage,
              pageSize:this.pageSize,
              telnumber:this.employeeMobile,
              agentNum:this.agentNumber,
              agentname:this.agentname,
              lastCallTime:this.starEndTime.length==0?"":this.starEndTime.toString(),
              pstnNumber:this.pstnNumber,
            };
            this.$http.post("calltask/callMonitor.json",param) .then(function (res) {
              let result=res.data.flag;
              if(result!="666"){
                that.$Modal.info({
                  title:'提示',
                  content:res.data.msg
                });
                return false;
              }
              that.infoTableList=res.data.obj.list.content;
              that.total=res.data.obj.list.totalSize;
              that.agentStatus=res.data.obj.agentStatus;
            });
          },
          initCountdown:function () {
            this.countdownTime=this.countdownTime-1;
            if(this.countdownTime==0){
              this.countdownTime=parseInt(this.countdown);
              this.initSearch();
              return false;
            }
          }
        },
        created(){
          this.screenHeight.height=this.mountHeight(91);
          this.tableHeight.height = this.mountHeight(252);

        },
        destroyed(){
          clearInterval(this.Interval);
        },
        watch:{
          pageCode:function () {
            if(this.pageCode=='2_3' && this.showPageCount==0){
              this.showPageCount++;
              this.initSearch();
              let that=this;
              this.Interval= setInterval(() =>{
                that.initCountdown();
              },1000);
            }
            if(this.pageCode=='2_3'){
              this.handleCountdown();
            }
            if(this.pageCode!='2_3'){
              clearInterval(this.Interval);
            }
          }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/callManage/CallOutMonitor.vue